import { createRequestTypes } from '../utils';

export const FETCH_IMPACT_ASSESSMENT_ACTIONS = createRequestTypes(
  'impactAssessmentAction/FETCH_IMPACT_ASSESSMENT_ACTIONS',
);
